module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/vi/1-cce46603e19474a1a515f011f078170e.jpg";